import api from '@/api/userApi';
import BaseModule from "@/common/BaseModule";
import { Module, Store } from "vuex";
import { LOAD_MINE_FAVORITES, LOAD_MOVIE_ALBUM_PAGE, LOAD_MOVIE_PLAYER_PAGE, LOAD_CHANNELS_MOVIE, LOAD_CHANNELS_MOVIE_PLAYER, LOAD_CHANNELS_SHORT } from '../protocols';
import { wrap401 } from '../user';
import fy2Api from '@/api/fy2Api';
import userApi from '@/api/userApi';
export interface State {
    list: Favorite[],
    shorts: Array<{ id: number, title: string, thumb: string }>,
    articles: Array<{ tid: number, title: string }>
    page: number,
    total: number,
}

class Favorites extends BaseModule<State> {
    constructor() {
        super(LOAD_MINE_FAVORITES[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                list: [],
                shorts: [],
                articles: [],
                page: 1,
                total: 0,
            },
            mutations: {
                update(state, { list, page, total }) {
                    state.list = list;
                    state.page = page
                    state.total = total
                },
                clear(state) {
                    state.list = []
                }
            },
            actions: {
                [LOAD_MINE_FAVORITES[1]](store) {
                    return wrap401(store, async () => {
                        let { data, current_page, total } = await api.getFavorites(1, 999)
                        store.commit('update', { list: data, page: current_page, total: total })
                        store.dispatch(LOAD_MOVIE_ALBUM_PAGE[0] + '/refreshFavorite', {}, { root: true })
                        store.dispatch(LOAD_MOVIE_PLAYER_PAGE[0] + '/refreshFavorite', {}, { root: true })
                        store.dispatch(LOAD_CHANNELS_MOVIE[0] + '/refreshFavorite', {}, { root: true })
                        store.dispatch(LOAD_CHANNELS_MOVIE_PLAYER[0] + '/refreshFavorite', {}, { root: true })
                    })
                },
                loadShorts(store) {
                    return wrap401(store, async () => {
                        let { list } = await fy2Api.getMyShorts()
                        for (let item of list) {
                            item.id = item.vid
                        }
                        store.state.shorts = list
                        store.dispatch(LOAD_CHANNELS_SHORT[0] + '/refreshFavorite', {}, { root: true })
                    })
                },
                remove(store, i: number) {
                    return wrap401(store, async () => {
                        let item = store.state.list[i]
                        await api.removeFavorite({ movid: item.movid, id: item.id })
                        store.state.list.splice(i, 1)
                    })
                },
                clear(store) {
                    return wrap401(store, async () => {
                        await api.clearFavorites()
                        store.commit('update', { list: [], page: 1 })
                    })
                },
                async addId({ state }, { id, channel_id }) {
                    await api.addFavorite(id)
                    state.list.push({
                        movid: id, id: 0, channel_id, create_time: 0, movie: {
                            movid: id,
                            title: '',
                            speaker: '',
                            thumb: '',
                            addtime: 0,
                            edittime: 0
                        }
                    })
                },
                async removeId({ state }, id: number) {
                    await api.removeFavorite({ movid: id })
                    let i = state.list.findIndex(item => item.movid == id)
                    if (i >= 0) {
                        state.list.splice(i, 1)
                    }
                },
                async addShort({ state }, id: number) {
                    await fy2Api.setMyShort(id)
                    state.shorts.push({
                        id: id,
                        title: '',
                        thumb: ''
                    })
                },
                async removeShort({ state }, id: number) {
                    await fy2Api.setMyShort(id)
                    let i = state.shorts.findIndex(item => item.id == id)
                    if (i >= 0) {
                        state.shorts.splice(i, 1)
                    }
                },
                async loadArticles(store) {
                    return wrap401(store, async () => {
                        let r = await userApi.getCollects(store.state.page, 999)
                        store.state.articles = r.data
                    })
                }
            }
        }
    }

    loadList(store: Store<any>) {
        store.dispatch(this.key(LOAD_MINE_FAVORITES[1]))
    }

    addId(store: Store<any>, id: number, channel_id: number = 0) {
        return store.dispatch(this.key('addId'), { id, channel_id })
    }

    removeId(store: Store<any>, id: number) {
        return store.dispatch(this.key('removeId'), id)
    }

    remove(store: Store<any>, index: number) {
        return store.dispatch(this.key('remove'), index)
    }

    clear(store: Store<any>) {
        return store.dispatch(this.key('clear'))
    }

    loadShort(store: Store<any>) {
        store.dispatch(this.key('loadShorts'))
    }

    addShort(store: Store<any>, id: number,) {
        return store.dispatch(this.key('addShort'), id)
    }

    removeShort(store: Store<any>, id: number,) {
        return store.dispatch(this.key('removeShort'), id)
    }

    loadArticles(store: Store<any>) {
        store.dispatch(this.key('loadArticles'))
    }
}

export default new Favorites()